// extracted by mini-css-extract-plugin
export default {"root":"SecondaryPanel_root__VI2hX"};